import { Box, Text } from '@chakra-ui/react'
import DescriptionComp from '../components/DescriptionComp';
import Hello from '../components/Hello';
import Percorso from '../components/Percorso';
import PersonalitaComp from '../components/PersonalitaComp';
import Sponsor from '../components/Sponsor';
import StradePiazzeComp from '../components/StradePiazzeComp';
import { useEffect, useRef } from 'react';

const Home = () => {
    const ref = useRef();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleClick = () => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <Box w={['100%', '360px', '820px', '100%']}>
            <Hello handleClick={handleClick} />

            <Box display='flex' alignItems='center' justifyContent='center' w='full' flexDirection='column'>

                <Box ref={ref}>
                    <DescriptionComp />
                </Box>

                <Box width='full' display='flex' alignItems='center' py={[4, 8, 8]} paddingLeft={[2, 8, 2, 16]}>
                    <Text textColor='white' fontSize={['2xl', '3xl', '3xl']} fontWeight='semibold' textAlign='left' letterSpacing='wider' >Due Percorsi</Text>
                </Box>
                <Percorso />
                <Box width='full' display='flex' alignItems='center' py={[4, 8, 8]} paddingLeft={[2, 8, 2, 16]}>
                    <Text textColor='white' fontSize={['2xl', '3xl', '3xl']} fontWeight='semibold' textAlign='left' letterSpacing='wider'>Parteciperanno </Text>
                </Box>
                <PersonalitaComp />
                <Box width='full' display='flex' alignItems='center' py={[4, 8, 8]} paddingLeft={[2, 8, 2, 16]}>
                    <Text textColor='white' fontSize={['2xl', '3xl', '3xl']} fontWeight='semibold' textAlign='left' letterSpacing='wider'>Luoghi</Text>
                </Box>
                <StradePiazzeComp />
                <Sponsor />
                <Text fontWeight='extrabold' textDecor='underline' textColor='white' my={2}>Pwd by Jacopo Berlingieri 2022 </Text>
            </Box>
        </Box>
    )
}

export default Home